var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"v-spinner color_green",style:(_vm.styleOptions)})
}
var staticRenderFns = []

export { render, staticRenderFns }